var _class, _temp;

var _templateObject = _taggedTemplateLiteralLoose(['\n  \n'], ['\n  \n']),
    _templateObject2 = _taggedTemplateLiteralLoose(['\n  padding: 1rem;\n  background-color: ', ';\n  color: ', ';\n'], ['\n  padding: 1rem;\n  background-color: ', ';\n  color: ', ';\n']),
    _templateObject3 = _taggedTemplateLiteralLoose(['\n  background: no-repeat center right url(', ');\n  width: 100%;\n  height: 22px;\n'], ['\n  background: no-repeat center right url(', ');\n  width: 100%;\n  height: 22px;\n']);

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled from 'styled-components';
import Spinner from '../Spinner';
import InputText from '../InputText';
import PlacesAutocomplete from 'react-places-autocomplete';
import { withTheme } from 'styled-components';
import Logo from './powered_by_google.png';
import { wrapAssetPath } from '../../../utils';
var Suggestions = styled.div(_templateObject);
var Suggestion = styled.div(_templateObject2, function (props) {
  return props.active ? function (props) {
    return props.theme.colours.primary.base;
  } : "transparent";
}, function (props) {
  return props.active ? function (props) {
    return props.theme.colours.primary.light_text;
  } : props.theme.colours.primary.base;
});
var GoogleLogo = styled.div(_templateObject3, function (props) {
  return wrapAssetPath(props.theme, Logo);
});
var AutoCompleteAddress = (_temp = _class = function (_React$Component) {
  _inherits(AutoCompleteAddress, _React$Component);

  function AutoCompleteAddress(props) {
    _classCallCheck(this, AutoCompleteAddress);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.onChange = function (address) {
      _this.setState({
        value: address
      });
    };

    _this.onSelect = function (address) {
      _this.setState({
        value: address
      });

      _this.props.onSelect(address);
    };

    _this.inputFocus = function (ev) {
      ev.target.select();
    };

    _this.inputBlur = function (ev) {
      _this.props.onSelect(ev.target.value);
    };

    _this.state = {
      value: _this.props.initialValue
    };
    _this.placeholder = _this.props.placeholder || 'Type your address ...';
    _this.props = props;
    AutoCompleteAddress.registerMapsInitCallback();
    _this.instanceCallbackName = AutoCompleteAddress.addInstanceCallback();
    return _this;
  }

  AutoCompleteAddress.mapsInitCallback = function mapsInitCallback() {
    Object.keys(AutoCompleteAddress.instanceCallbacks).map(function (key) {
      if (typeof window !== "undefined") {
        if (typeof window[key] !== "undefined") {
          window[key]();
        }
      }
    });
  };

  AutoCompleteAddress.registerMapsInitCallback = function registerMapsInitCallback() {
    if (typeof window !== "undefined") {
      if (typeof window["mapsInit"] === "undefined") {
        window["mapsInit"] = this.mapsInitCallback;
      }
    }
  };

  AutoCompleteAddress.addInstanceCallback = function addInstanceCallback() {
    var key = "mapsInit" + this.instanceCount;
    this.instanceCallbacks[key] = key;
    this.instanceCount++;
    return key;
  };

  AutoCompleteAddress.prototype.addMapsAPI = function addMapsAPI() {
    if (typeof document === 'undefined') return;
    if (document.getElementById("maps-script") !== null) return;
    var s = document.createElement('script');
    var apiKey = this.props.apiKey;
    var src = 'https://maps.googleapis.com/maps/api/js?key=' + apiKey + '&libraries=places&callback=mapsInit';
    s.setAttribute('src', src);
    s.setAttribute('id', "maps-script");
    document.body.appendChild(s);
  };

  AutoCompleteAddress.prototype.componentWillMount = function componentWillMount() {
    this.addMapsAPI();
  };

  AutoCompleteAddress.prototype.componentWillUnmount = function componentWillUnmount() {
    delete AutoCompleteAddress.instanceCallbacks[this.instanceCallbackName];
  };

  AutoCompleteAddress.prototype.render = function render() {
    var _this2 = this;

    return React.createElement(PlacesAutocomplete, {
      value: this.state.value,
      onChange: this.onChange,
      onSelect: this.onSelect,
      searchOptions: {
        types: ["address"],
        componentRestrictions: {
          country: ["za"]
        }
      },
      googleCallbackName: this.instanceCallbackName
    }, function (_ref) {
      var getInputProps = _ref.getInputProps,
          suggestions = _ref.suggestions,
          getSuggestionItemProps = _ref.getSuggestionItemProps,
          loading = _ref.loading;
      return React.createElement('div', null, React.createElement(InputText, getInputProps({
        placeholder: _this2.placeholder,
        onFocus: _this2.inputFocus,
        onBlur: _this2.inputBlur,
        disabled: _this2.props.disabled,
        name: _this2.props.name,
        hasError: _this2.props.hasError
      })), React.createElement(Suggestions, null, loading && React.createElement('div', {
        style: {
          display: "block",
          margin: "1rem auto",
          width: "32px"
        }
      }, React.createElement(Spinner, {
        width: '32px'
      })), !loading && suggestions.map(function (suggestion) {
        return React.createElement(Suggestion, getSuggestionItemProps(suggestion, {
          active: suggestion.active
        }), React.createElement('span', null, suggestion.description));
      }), suggestions.length > 0 && React.createElement(GoogleLogo, null)));
    });
  };

  return AutoCompleteAddress;
}(React.Component), _class.instanceCount = 0, _class.instanceCallbacks = {}, _temp);
export default withTheme(AutoCompleteAddress);